/**
 * The storage key `<ds-theme>` persists the reader's choice under. It is the
 * component's default; naming it here is what lets the choice be applied
 * before the component exists.
 */
const THEME_STORAGE_KEY = "ds:theme";

/**
 * Apply a stored light/dark choice before the first render.
 *
 * `<ds-theme>` only lives in the signed-in header, so without this the sign-in
 * screen would ignore the choice, and every other screen would paint in the
 * system theme and then switch. With nothing stored — or "system" — no
 * attribute is set and SDS follows the OS through `light-dark()`.
 */
export function applyStoredTheme(
  root: Pick<Element, "setAttribute">,
  storage: () => Pick<Storage, "getItem">,
): void {
  let stored: string | null;
  try {
    // Reading `window.localStorage` itself throws when site data is blocked,
    // so the lookup happens in here rather than at the call site.
    stored = storage().getItem(THEME_STORAGE_KEY);
  } catch {
    // Storage can be blocked outright; the system theme is the right answer.
    return;
  }
  const theme = stored?.trim().toLowerCase();
  if (theme === "light" || theme === "dark") {
    root.setAttribute("data-ds-theme", theme);
  }
}
